import { useCallback, useMemo, useState } from "react";

import api from "../../../../utils/api";
import {StringNull } from "../../../../types";

interface GetMembrosProps {

}

type ResponseMembrosCheckin = {
  listAll: {id: number, descricao: StringNull}[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: {id: number, descricao: StringNull}[]
  pagina: number
}

const GetPerfils = (): ResponseMembrosCheckin => {

  const [listSedes, setListSedes] = useState<{id: number, descricao: StringNull}[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<{id: number, descricao: StringNull}[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = (params: any) => {
    api.get<{id: number, descricao: StringNull}[]>('usuarioperfil', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListSedes(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }

  const getList = useCallback(async () => {
    api.get<{id: number, descricao: StringNull}[]>('usuarioperfil')
      .then(
        (sucesso) => {
          setListSedes(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, [resetar]);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listSedes,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams
  };
}

export default GetPerfils;
